import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { DeviceStatusFilter } from "@/components/dashboard/DeviceStatusFilter";
import DeviceList from "@/components/DeviceList";
import { useDevices, DEVICES_QUERY_KEY } from "@/hooks/useDevices";
import { getDeviceStatus } from "@/utils/deviceStatus";

const Dashboard = () => {
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const { data: devices = [], isLoading } = useDevices();

  const counts = devices.reduce((acc, device) => {
    const status = getDeviceStatus(device.last_seen || device.created_at, device.status);
    acc[status]++;
    acc.total++;
    return acc;
  }, { active: 0, inactive: 0, pending: 0, total: 0 });

  const handleStatusClick = (status: string | null) => {
    setStatusFilter(status === statusFilter ? null : status);
  };

  return (
    <div className="min-h-screen bg-background w-full">
      <div className="w-full px-6 py-6">
        <DashboardHeader />
        <DeviceStatusFilter
          statusFilter={statusFilter}
          onStatusClick={handleStatusClick}
          counts={counts}
          isLoading={isLoading}
        />
        <DeviceList statusFilter={statusFilter} onStatusClick={handleStatusClick} />
      </div>
    </div>
  );
};

export default Dashboard;
